import { Component, Input } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { TextComponent } from '../text/text.component';
import { CommonNgModule } from '../../../shared/modules/common-ng/common-ng.module';

@Component({
  selector: 'app-chip',
  standalone: true,
  imports: [
    CommonNgModule,
    IconComponent,
    TextComponent
  ],
  templateUrl: './chip.component.html',
  styleUrl: './chip.component.scss'
})
export class ChipComponent {
  @Input() Theme:any;
  @Input() Label:any;
  @Input() Ico:any;
  constructor() { }

  ngOnInit() {
  }
}
